module.exports = __webpack_public_path__ + "static/scale-model-of-newark-new-jersey-4986c2d4997edebcea2bc5997b7d1172.png";